import { DocumentNode } from 'graphql'
import { print } from 'graphql/language/printer'

const fetchApi = (query: DocumentNode, variables?: { [key: string]: any }) => {
  return fetch(process.env.REACT_APP_GRAPHQL_URL as string, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: print(query),
      variables
    }),
    cache: 'reload'
  }).then(response => response.json());
};

export default fetchApi;
